export const NULL_OPTION_NAME = 'None';
